"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressInput = void 0;
var React = _interopRequireWildcard(require("react"));
var _geosuggestWidget = require("@cian/geosuggest-widget");
var _clsx = _interopRequireDefault(require("clsx"));
var _ErrorPopover = require("../ErrorPopover");
var _widgetContext = require("../../context/widgetContext");
var styles = _interopRequireWildcard(require("./styles.css"));
var _FilterWrapper = require("../packages/FilterWrapper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AddressInput = props => {
  const {
    isDesktop,
    isMyHome
  } = React.useContext(_widgetContext.widgetContext);
  const isDesktopView = isDesktop && !isMyHome; // Для моего дома необхъодимо использовать мобильные компоненты

  const geoSuggestProps = {
    value: props.value,
    selectedValue: props.value,
    error: props.addressGeoSuggest.error,
    suggestData: props.addressGeoSuggest.suggestData,
    inputType: isDesktopView ? _geosuggestWidget.EInputType.map : _geosuggestWidget.EInputType.mobile,
    inputStyle: [props.className, !isDesktopView && props.errorMessage ? {
      border: '1px solid #ff1f34'
    } : {}],
    onItemClick: props.onItemClick,
    onValueChange: props.onValueChange,
    popupStyle: styles['suggest-popup'],
    placeholder: props.placeholder,
    itemsTruncation: isDesktopView ? _geosuggestWidget.ETruncation.One : _geosuggestWidget.ETruncation.Two,
    flip: false
  };
  return /*#__PURE__*/React.createElement(_FilterWrapper.FilterWrapper, {
    isFirstFilter: props.isFirstFilter,
    isLastFilter: props.isLastFilter
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['input-container'], isDesktopView ? styles['input-container-desktop'] : styles['input-container-not-desktop']),
    onClick: props.onInputTagClick
  }, /*#__PURE__*/React.createElement(_ErrorPopover.ErrorPopover, {
    tooltipContent: props.errorMessage || '',
    wrapWith: "div"
  }, /*#__PURE__*/React.createElement(_geosuggestWidget.GeoSuggest, geoSuggestProps))));
};
exports.AddressInput = AddressInput;
AddressInput.displayName = 'AddressInput';